import { CrossIcon } from '../../../assets/icons'
import { capitalize } from '../../../utils/utils';
import { cn } from '../../../lib/cn';

export const Chip = ({ text, onClick, cross = true, variant }) => {
  const capitalizedText = text?.split(' ')?.map((item) => capitalize(item))?.join(' ');
  const clickable = !cross && typeof onClick === 'function';

  const handleKeyDown = (event) => {
    if (!clickable) return;
    if (event.key === 'Enter' || event.key === ' ' || event.key === 'Delete' || event.key === 'Backspace') {
      event.preventDefault();
      onClick(event);
    }
  };

  return (
    <span
      className={cn(
        'inline-flex items-center gap-2 justify-center rounded-full px-4 py-2 select-none',
        variant === 'filled'
          ? 'bg-secondary border border-secondary text-white'
          : 'bg-none border border-darkgrey text-darkgrey',
        clickable && 'cursor-pointer focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-secondary/60 focus-visible:ring-offset-2',
      )}
      onClick={clickable ? onClick : undefined}
      role={clickable ? 'button' : undefined}
      tabIndex={clickable ? 0 : undefined}
      onKeyDown={clickable ? handleKeyDown : undefined}
    >
      <p className="whitespace-nowrap text-sm font-sans font-semibold">
        {capitalizedText}
      </p>

      {cross ? (
        <button
          type="button"
          aria-label={`Remove ${capitalizedText}`}
          className="rounded-full p-0.5 transition text-current cursor-pointer hover:opacity-70 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-secondary/60"
          onClick={onClick}
        >
          <CrossIcon width={16} height={16} />
        </button>
      ) : null}
    </span>
  );
};
